//
// GroupByInfo.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../../models/BIRDModel";
import "../../models/dataDefinition/DataItem";
import "./DataItemInfo";

var GroupByInfo = createModule("BIRD::GroupByInfo", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        groupBy: 1,
        label: 7,
        detail: 2,
        dataItemInfo: 1,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default GroupByInfo;
